import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.IDAutoDetalhe = 0;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;

};
export const dataGet13 = async () => {
    return data;
};

// export const getItems13 = async () =>  {
//     console.log("services13")   
//     return data
// };
export const getItems13 = async () =>  {
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
            for (let i = 0; i < Detalhes.autoGridViatura.length ; i++) {
                var EntidadesInstEng = Detalhes.autoGridViatura[i].idAgenteEconomicoVendas;
                var idContaCorrenteEngarrafado = Detalhes.autoGridEngarrafado[i].idContaCorrenteVendas == -2 ? 'Outros' : Detalhes.autoGridEngarrafado[i].idContaCorrenteVendas == -1 ? 'ProdutosSemConta' : Detalhes.autoGridEngarrafado[i].idContaCorrenteVendas;
                var idProdutoSemContaEnga = Detalhes.autoGridViatura[i].produtosSemContaVendas;
                var dataVenda = Detalhes.autoGridViatura[i].dataVendas;
                var idDocumentoVendas = Detalhes.autoGridViatura[i].idDocumento;
                var NumerosVendas = Detalhes.autoGridViatura[i].numeroVendas;
                var NumeroGarrafasAE = Detalhes.autoGridViatura[i].numeroGarrafasAE;
                var capacidadeEngarrafado = Detalhes.autoGridViatura[i].capacidadeVendas;
                var VolumesVendas = Detalhes.autoGridViatura[i].volumeVendas;
                var Destinatarios =  Detalhes.autoGridViatura[i].destinatario;
                var Moradas =  Detalhes.autoGridViatura[i].morada;
                var ObservacoesV = Detalhes.autoGridViatura[i].observacoesVendas;
                var idAutoDetalhe1 = Detalhes.autoGridViatura[i].idAutoDetalhe;
                var ano = Detalhes.autoGridEngarrafado[i].anoVendas;
                var idcor = Detalhes.autoGridEngarrafado[i].idCorVendas
                data.push({ 
                    idEntidadesInst : EntidadesInstEng,
                    EntidadesInst : EntidadesInstEng,
                    idContaCorrenteEng: idContaCorrenteEngarrafado,
                    idProdutosSemConta : idProdutoSemContaEnga,
                    idDocumento : idDocumentoVendas,
                    DataVendas: dataVenda,
                    NumeroVendas: NumerosVendas,
                    NumeroGarrafasVendas: NumeroGarrafasAE,
                    idCapacidadeEng: capacidadeEngarrafado,
                    VolumeVendas: VolumesVendas,
                    Destinatario: Destinatarios,
                    Morada: Moradas,
                    Observacoes: ObservacoesV,
                    idAutoDetalhe: idAutoDetalhe1,
                    Ano: ano,
                    idCor: idcor,
                    Discontinued: false,
                    Columns: [],
                    inEdit: false,
                    ProductID: i + 1,
                })
            }
            return data;
        
    }else{
         return data
    }
    
};
export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
